import { Trans } from 'react-i18next';
import FeatureCard from '../components/FeatureCard';
import ModernPropertyDropdown from '../modern/PropertyDropdown';
import PropertyDropdown from '../components/PropertyDropdown';
import { getMinutes } from '../../../../../../../utils/constantValues';

const AstroFadeTimingCluster = ({
    switchOnFadeTime,
    astroDimFadeTime,
    switchOffFadeTime,
    showSwitchOff,
    handleChange,
    className,
    variant,
    style
}) => {
    const Dropdown = variant === 'modern' ? ModernPropertyDropdown : PropertyDropdown;
    return (
        <FeatureCard title={<Trans i18nKey="Fade_Timing" />} className={className} style={style} variant={variant} bodyLayout="fields">
            <Dropdown
                property={switchOnFadeTime}
                properties={switchOnFadeTime.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                propertyDisplayFunc={getMinutes}
                title={<Trans i18nKey="Switch_On_Fade_Time" />}
                measureUnit={'mm:ss'}
                min={switchOnFadeTime.valueMeta.min}
                max={switchOnFadeTime.valueMeta.max}
                handleChange={handleChange} />
            <Dropdown
                property={astroDimFadeTime}
                properties={astroDimFadeTime.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                propertyDisplayFunc={getMinutes}
                title={<Trans i18nKey="AstroDIM_Fade_Time" />}
                measureUnit={'mm:ss'}
                min={astroDimFadeTime.valueMeta.min}
                max={astroDimFadeTime.valueMeta.max}
                handleChange={handleChange} />
            {showSwitchOff
                ?
                <Dropdown
                    property={switchOffFadeTime}
                    properties={switchOffFadeTime.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                    propertyDisplayFunc={getMinutes}
                    title={<Trans i18nKey="Switch_Off_Fade_Time" />}
                    measureUnit={'mm:ss'}
                    min={switchOffFadeTime.valueMeta.min}
                    max={switchOffFadeTime.valueMeta.max}
                    handleChange={handleChange} />
                :
                null}
        </FeatureCard>
    );
};

export default AstroFadeTimingCluster;
